// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__m2bY1","main":"Button_main__dkWsC","secondary":"Button_secondary__8XtHH"};